import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { Table } from "semantic-ui-react";
import moment from "moment";
import styles from "./DartsScoringTracker.module.scss";
import { useAppSelector } from "../../../../hooks/hooks";
import { useAppDispatch } from "../../../../hooks/hooks";
import { ICurrentShootOutGame, IFirstPlayerPayloadData } from "../../../../pages/Darts/Scoring/DartsScoring.types";
import { getSeparateDisplayNames } from "../../../../helpers/getSeparateDisplayNames";
import { IdName } from "../../../../common/types/IdName";

import { api } from "../../../../services/api/api.service";
import { AxiosResponse } from "axios";
import { setFirstPlayer } from "../../../../pages/Darts/Scoring/DartsScoring.thunk";
import { DartsGameType } from "../../../../common/types/DartsGameTypes";
import { DartsGameStatus } from "../../../../common/types/DartsGameStatuses";
import { API_DARTS_SHOOTOUT_GAMES } from "../../../../services/api/api.urls";
import { isNull } from "lodash";

const DartsScoringTracker: React.FC = React.memo(() => {
    const dispatch = useAppDispatch();
    const _game = useAppSelector(state => state.DartsScoring.game);
    const _playerId = useAppSelector(state => state.DartsScoring.playerId);
    const _dateStart = useAppSelector(state => state.DartsScoring.dateStart);
    const [currentGameInfo, setCurrentGameInfo] = useState<ICurrentShootOutGame | null>(null)
    const [numOfColumns, setNumOfColumns] = useState(_game?.players?.length);
    //const { turnScores, players } = initData


    const basicStyles: React.CSSProperties = {
        width: "33.3333%",
        height: "100%",
        position: "absolute",
        background: "#fbbd08",
        color: '#454d55'
    };
    //const getActiveGameInfo = async (gameId: number) => {
    //    try {
    //        const resp: AxiosResponse = await api.get(`${API_DARTS_SHOOTOUT_GAMES}/${gameId}`)
    //        const DartsGames9Shots: ICurrentShootOutGame = resp.data;
    //        setCurrentGameInfo(DartsGames9Shots);
    //    } catch (e) {
    //        if (e instanceof Error) {
    //            console.log(e.message)
    //        }
    //    }
    //};

    //useEffect(() => {
    //    if (game.gameId) {
    //        getActiveGameInfo(game.gameId)
    //    }
    //}, [game.gameId]);

    const getSelectedColumnStyle = (id: number | null) => {
        //const index = game.players.findIndex(player => player.id === id);
        if (!_playerId) {
            return { ...basicStyles, display: "none" };
        } else if (id === _game.players[0].id) {
            return { ...basicStyles, right: "67%" };
        } else if (id === _game.players[1].id) {
            return { ...basicStyles, right: '33%' };
        } else if (id === _game.players[2].id) {
            return { ...basicStyles, right: 0 };
        }
    };

    const getTextColorForColumn = (id: number | undefined) =>
        id === _playerId ? { color: "#454d55" } : { color: "white" };

    const setFirstPlayerLocal = (playerId: number | null) => {
        console.log('_game.status', _game.status);
        if (_game.status !== DartsGameStatus.Running) {
            toastr.warning("Game not in status Running. Can not change first player.");
            return;
        }
        if (_dateStart) { //Info: dateStart ��������������� ��� ������ ������
            toastr.warning("Game already started. First player can not be changed.");
            return;
        }
        if (_playerId !== undefined) {
            return;
        }
        let payload: IFirstPlayerPayloadData = {
            playerId: playerId === _playerId ? null : playerId
        }
        dispatch(setFirstPlayer(payload))
    };

    //const onSelect = () => { // playerId, player, payload
    //    if (game.status !== DartsGameStatus.Running) {
    //        setIsOpenModal(true);
    //        return setTimeout(() => setIsOpenModal(false), 1500);
    //        onSelect(payload)
    //    }
    //}
    useEffect(() => {
        if (!_playerId || isNull(_playerId) || _playerId === 0) {
            return;
        }
        // ���������� ������� �������� ������
    }, [_playerId]);

    const canClick: boolean = _playerId ? true : false;

    console.log('numOfColumns', numOfColumns);
    return (
        <Table inverted className={styles.tracker_table}>
            <Table.Header className={styles.tracker_table_header}>
                <Table.Row>
                    {_game.players?.map(player => {
                        return (
                            <Table.HeaderCell style={getTextColorForColumn(player.id)} onClick={canClick ? setFirstPlayerLocal : undefined} >
                                <Player
                                    player={player}
                                    onClick={setFirstPlayerLocal}
                                    gameId={_game.gameId}
                                    currentPlayerId={_playerId}
                                />
                            </Table.HeaderCell>
                        )
                    })}
                </Table.Row>
            </Table.Header>
            <Table.Body>
                <Table.Row>
                    {_game.players?.map((player, playerIndex) => {
                        return (
                            <Table.Cell className={styles.tracker_table_cell}>
                                {_game.turnScores && _game.turnScores[playerIndex]?.map((score, scoreIndex) => {
                                    return (
                                        <div key={scoreIndex}>
                                            <div style={{ paddingBottom: "10px" }}>
                                                {score}
                                            </div>
                                        </div>
                                    )
                                })}
                            </Table.Cell>
                        )
                    })}
                </Table.Row>
            </Table.Body>
        </Table>
    );
}) 

interface IPlayerProps {
    player: IdName;
    leg?: number;
    onClick: (playerId: any, currentPlayer: any, payload: any) => void;
    gameId: number;
    currentPlayerId: number | null;
}

const Player: React.FC<IPlayerProps> = (
    {
        player,
        onClick,
        leg,
        gameId,
        currentPlayerId
    }) => {
    const payload = {
        gameId,
        player,
        date: moment().utc().toDate(),
    };
    return (
        <div className="player-name__shoot-container" onClick={() => onClick(currentPlayerId, player, payload)} >
            <div className="player-name__score">{leg}</div>
            <div className="player-name__shoot-details">
                <div className="player-name__shoot-details-name">{getSeparateDisplayNames(player.name).name}</div>
                <div className="player-name__shoot-details-surname">{getSeparateDisplayNames(player.name).surname}</div>
            </div>
        </div>
    );
};

export default DartsScoringTracker;
